import { useEffect, useState } from "react"
import { useTranslation } from "react-i18next"
import { useSearchParams } from "react-router-dom"
import introJs from 'intro.js'
import { getPalette } from "@/assets/themes/palette";

const palette = getPalette();


function injectStyles() {
  const css = `
    .introjs-tooltip {
      background-color: ${palette.common.white};
    }
    
    .introjs-button,
    .introjs-button:hover, .introjs-button:focus, .introjs-button:active,
    .introjs-disabled, .introjs-disabled:focus, .introjs-disabled:hover {
      outline: none;
      background-image: none;
      background-color: transparent;
      color: ${palette.primary.main};
      border: 1px solid transparent;
      border-radius: 50px;
      box-shadow: none;
      border-shadow: none;
      text-shadow: none;
    }
    
    .introjs-button:hover, .introjs-button:focus, .introjs-button:active {
      border: 1px solid ${palette.primary.main}
    }
    .introjs-disabled, .introjs-disabled:focus, .introjs-disabled:hover {
      color: ${palette.background.idle};
      border: 1px solid transparent;
    }
    
    .introjs-arrow {
      border: 10px solid ${palette.primary.main};
    }
    .introjs-arrow.top, .introjs-arrow.top-middle, .introjs-arrow.top-right {
      border-color: transparent transparent rgba(000, 0, 0, 0.5);
      top: -20px;
      left: 20px;
    }
    .introjs-arrow.bottom, .introjs-arrow.bottom-middle, .introjs-arrow.bottom-right {
      border-color: rgba(000, 0, 0, 0.5) transparent transparent;
      bottom: -20px;
      left: 20px;
    }
    .introjs-arrow.left, .introjs-arrow.right {
        top: 20px;
    }
    .introjs-arrow.left-bottom, .introjs-arrow.right-bottom {
        bottom: 20px;
    }
    
    .introjs-arrow.left, .introjs-arrow.left-bottom {
      left: -20px;
      border-color: transparent rgba(000, 0, 0, 0.5) transparent transparent;
    }
    .introjs-arrow.right, .introjs-arrow.right-bottom {
      right: -20px;
      border-color: transparent transparent transparent rgba(000, 0, 0, 0.5);
    }
  `;

  const head = document.head || document.getElementsByTagName('head')[0];
  const style = document.createElement('style');
  style.type = 'text/css';
  style.appendChild(document.createTextNode(css));


  head.appendChild(style);
}

export function useIntro(steps: { element?: string, intro: string }[], condition?: boolean) {
  const [searchParams] = useSearchParams()
  const [introEnabled, setIntroEnabled] = useState(false)

  useEffect(() => {
    if (searchParams?.get('intro') === 'true') {
      setIntroEnabled(true)
    }
  }, [searchParams])

  const { t } = useTranslation()



  useEffect(() => {
    if ((introEnabled === false) || !condition) {
      return
    }
    injectStyles();  // Call this function to inject styles

    setTimeout(() => {
      introJs()
        .setOptions({
          tooltipClass: 'introjs-tooltip',
          steps: steps.map((step) => {
            return {
              ...step,
              intro: t(`page.onboarding.intro.${step.intro}`),
            }
          }),
        })
        .start()
    }, 2000)
  }, [introEnabled, steps, condition, t])

  return introEnabled
}